import React from 'react';

import Avatar from 'components/Participants/Avatar';

class Vote extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      choice: this.props.vote.choice
    };
  }

  render() {
    let choice = "vote";

    switch (this.state.choice) {
      case 0:
        choice += " vote-no";
        break;
      case 1:
        choice += " vote-maybe";
        break;
      case 2:
        choice += " vote-yes";
        break;
    }

    return (
      <td className={choice}>
        <Avatar participant={this.props.voter} />
      </td>
    );
  }
}

export default Vote;
